import { Outlet } from "react-router";

export default function NotLoginLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}
